import { useSelector } from "@tanstack/react-store";
import { chartDateRangeStore, setChartDateRangeState } from "../../stores/chartDateRangeStore";
import type { DateRange, RecentPeriod } from "../../types/date";
import { DateRangePicker } from "../DateRangePicker/DateRangePicker";

export const OverallPerformanceDateRangePicker = () => {
  const { startDate, endDate, quickSelect } = useSelector(chartDateRangeStore, (state) => state);

  const handleSubmit = ({ startDate, endDate }: DateRange, quickSelect?: RecentPeriod) => {
    setChartDateRangeState({ startDate, endDate, quickSelect });
  };

  return <DateRangePicker dateRange={{ startDate, endDate }} quickSelect={quickSelect} onSubmit={handleSubmit} />;
};
